import { ENTERPRISE_USER_FOLLOW_LIST } from '@/constant/QueryKeyName';
import { DEFAULT_AVT_IMG } from '@/constant/imgImport';
import { IUserProfileData } from '@/interfaces/profile.interface';
import { getFollowList } from 'apis/profile.api';
import { AxiosResponse } from 'axios';
import { convertQuantityToLocaleString } from 'common/quantityHelpers';
import { useQuery } from 'react-query';
import EnterpriseUserList from './EnterpriseUserList';

function EnterpriseFollowerSection({
  profileData,
}: {
  profileData: IUserProfileData | undefined;
}) {
  const profiles = profileData?.profiles;
  const uid = `${profileData?.profiles?.ownerId}`;

  const { data } = useQuery<AxiosResponse<any, any>, Error, any[]>(
    [ENTERPRISE_USER_FOLLOW_LIST, uid],
    () => getFollowList(uid),
    {
      enabled: !!uid,
      select(data) {
        return data.data.isFollowedBy.filter((item: any) => item.isAccepted);
      },
    }
  );

  return (
    <div className="flex justify-end gap-2 md:items-center">
      <div className="hidden md:block">
        <EnterpriseUserList
          avatarList={
            data
              ?.map((user) => user?.profileId?.avatar ?? DEFAULT_AVT_IMG)
              .slice(0, 5) || []
          }
        />
      </div>
      <p className="text-sm font-medium leading-[120%] text-Text/Lightbackground/Secondary">
        {convertQuantityToLocaleString(profiles?.isFollowedBy.length || 0)}{' '}
        thành viên
      </p>
    </div>
  );
}

export default EnterpriseFollowerSection;
